import { useEffect } from 'react';

import { useExtensionType } from '../store';

/**
 * Logs the current extension_type for debugging.
 */
export function useLogExtensionType(): void {
  const extensionType = useExtensionType();

  useEffect(() => {
    if (extensionType !== undefined) {
      // eslint-disable-next-line no-console
      console.log('[WebRTC] extension_type:', extensionType);
    }
  }, [extensionType]);
}
